module.exports = __webpack_public_path__ + "abf5878381a2df32eba8b0d38b53f94b.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/news.png
 ** module id = 1545
 ** module chunks = 0
 **/